import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

import { PageGrid } from '../shared/CommonStyledComponents';
import NextPageLink from '../shared/NextPageLink';

import { workData } from '../data';

import workBg from '../assets/images/work-bg.svg';
import arrow from '../assets/images/arrow.png';
import ourClientsSideLink from '../assets/images/sideLinks/our_clients_side_link.svg';


const WorkRow = styled(Row)`
  width: 85%;

  @media (max-width: 64em) {
    width: auto;
  }
`;

const SelectedWorkContainer = styled.div`
  height: 59vh;
  align-items: center;
  display: flex;

  @media (max-width: 64em) {
    flex-direction: column;
    height: 100%;
  }
`;

const WorkBGImage = styled.img`
  position: absolute;
  height: 100%;

  @media (max-width: 64em) {
    height: auto;
    width: 100%;
  }
`;

const SelectedWorkImage = styled.img`
  margin-left: 2vw;
  z-index: 22;
  padding: 3px;
  background-color: #fff;
  border: 1px solid;
  width: 42%;
  opacity: 1;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;

  @media (max-width: 64em) {
    margin-top: 9vh;
    margin-bottom: 8vh;
  }
`;

const SelectedWorkDetails = styled.div`
  padding: 24px;
  z-index: 22;
  opacity: 1;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
`;

const SelectedWorkTitle = styled.h2`
  font-size: 1.6vw;
  margin-bottom: 10px;

  @media (max-width: 64em) {
    font-size: 4.6vw;
    text-align: center;
  }
`;

const SelectedWorkClient = styled.span`
  font-size: 1vw;
  border-bottom: 1px solid;
  width: 100%;
  display: block;
  padding-bottom: 10px;

  @media (max-width: 64em) {
    font-size: 3vw;
    text-align: center;
  }
`;

const SelectedWorkDescription = styled.p`
  font-size: 1vw;

  @media (max-width: 64em) {
    font-size: 3vw;
  }
`;

const MoreWorkSection = styled(Col)`
  border-left: 1px solid;

  @media (max-width: 64em) {
    border: none;
  }
`;

const MoreWorkRow = styled(Row)`
  height: 100%;
  align-items: center;
  opacity: 1;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
`;

const MoreWorkColumn = styled(Col)`
  border-right: 1px solid;
  overflow: hidden;
  padding: 4vh 0px;
  cursor: pointer;
`;

const MoreWorkImage = styled.img`
  margin-left: 3vw;
  width: 22vw;
  background-color: #ff177c;
  padding: 3px;
  -webkit-transition: margin-left 0.4s;
  transition: margin-left 0.4s;

  &:hover{
    margin-left: 2vw;
  }
`;

const ExpandMoreWorkLink = styled.span`
  margin-left: calc(3vw - 3px);
  font-size: 1vw;
  cursor: pointer;

  @media (max-width: 64em) {
    margin-bottom: 2vh;
    display: block;
    font-size: 3vw;
  }
`;

const ExpandMoreWorkArrow = styled.img`
  margin-left: 2vw;
  width: 2.4vw;
  display: inline-block;

  @media (max-width: 64em) {
    width: 5.4vw;
  }
`;

const createMarkup = html => ({ __html: DOMPurify.sanitize(html, {
  ADD_ATTR: ['target']
}) });

class Work extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedWorkId: 1,
      workListSummary: true
    };

    this.selectWork = this.selectWork.bind(this);
    this.showAllWork = this.showAllWork.bind(this);
  }

  selectWork(id) {
    const selectedWorkImg = document.getElementById('selected-work-img');
    const selectedWorkDetails = document.getElementById('selected-work-details');

    selectedWorkImg.classList.add('updating');
    selectedWorkDetails.classList.add('updating');

    setTimeout(() => {
      this.setState({
        selectedWorkId: id
      });

      selectedWorkImg.classList.remove('updating');
      selectedWorkDetails.classList.remove('updating');
    }, 400);
  }

  showAllWork() {
    const { workListSummary } = this.state;
    const moreWorkList = document.getElementById('more-work-list');

    moreWorkList.classList.add('updating');

    setTimeout(() => {
      this.setState({
        workListSummary: !workListSummary
      });

      moreWorkList.classList.remove('updating');
    }, 400);
  }

  render() {
    const { selectedWorkId, workListSummary } = this.state;

    const selectedWork = workData.find(work => work.id === selectedWorkId);

    let workList = workData;

    if (workListSummary) {
      workList = workList.slice(0, 4);
    }

    return (
      <PageGrid id="work">
        <WorkRow>
          <Col xs={12} md={8}>
            <SelectedWorkContainer bgSrc={workBg}>
              <WorkBGImage src={workBg} alt="Work bg" />
              <SelectedWorkImage
                src={selectedWork.image}
                alt="Selected work"
                id="selected-work-img"
              />
              <SelectedWorkDetails id="selected-work-details" className="styled-links">
                <SelectedWorkTitle>{selectedWork.title}</SelectedWorkTitle>
                <SelectedWorkClient>{selectedWork.client}</SelectedWorkClient>
                {selectedWork.description.map((description, index) =>
                  (<SelectedWorkDescription
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    dangerouslySetInnerHTML={createMarkup(description)}
                  />)
                )}
              </SelectedWorkDetails>
            </SelectedWorkContainer>
          </Col>

          <MoreWorkSection xs={12} md={4}>
            <ExpandMoreWorkLink onClick={this.showAllWork}>
              see more of our best work <ExpandMoreWorkArrow src={arrow} alt="" />
            </ExpandMoreWorkLink>

            <MoreWorkRow id="more-work-list">
              {workList.map(work => (<MoreWorkColumn
                xs
                key={work.id}
                onClick={() => { this.selectWork(work.id); }}
              >
                <MoreWorkImage src={work.image} alt={work.title} />
              </MoreWorkColumn>))}
            </MoreWorkRow>
          </MoreWorkSection>
        </WorkRow>

        <NextPageLink
          color="ff177c"
          image={ourClientsSideLink}
          text="OUR CLIENTS"
        />
      </PageGrid>
    );
  }
}

export default Work;



// WEBPACK FOOTER //
// ./src/components/Work.js